<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h2>Notice</h2>
        <p>
          온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
          제공하겠습니다.
        </p>
      </div>
    </section>

    <!-- container -->
    <main id="cont">
      <div class="img" style="text-align: center">
        <v-img
          src="@/assets/img/common/noti.jpg"
          alt=""
          class="responsive-img"
        />
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang="css">
@import "@/assets/css/captcha.css";

.responsive-img {
  border-style: solid;
  border-width: 3px;
  max-width: 1040px;
  margin: 0 auto;
}
</style>
